import { Redirect } from 'expo-router';

export default function PeopleIndexRedirect() {
  return <Redirect href="/people/online" />;
}
